import { render, staticRenderFns } from "./edite-bsk-match.vue?vue&type=template&id=44cfbbcb&scoped=true"
import script from "./edite-bsk-match.vue?vue&type=script&lang=js"
export * from "./edite-bsk-match.vue?vue&type=script&lang=js"
import style0 from "./edite-bsk-match.vue?vue&type=style&index=0&id=44cfbbcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cfbbcb",
  null
  
)

export default component.exports